<template>
  <div :style="{height: hh + 'px'}">
    <iframe
      :src="url"
      frameborder="0"
      style="width:100%;height:100%;border:0;"
      title="企业数据统计分析">
    </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hh: 500,
      url: '/enterprisedata.html'
    }
  },
  created() {
    // 减去页面头部等高度，确保 iframe 占满剩余空间
    this.hh = document.documentElement.clientHeight - 260;
  }
}
</script>

<style scoped>

.welcome {
  /* background: url("~@/assets/loginbg.jpg") no-repeat; */
  /* background-size: cover; */
  line-height: 60px;
  text-align: left;
  padding: 100px 20px 0 100px;
  /* color: white; */
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',
    'Lucida Sans', Arial, sans-serif;
}

.numberfont {
  font-size: 30px;
  color: darkred;
  font-weight: bold;
}
</style>
